export const LAYERFILE = 'LAYERFILE'